import React, { useState, useEffect } from 'react';
import styles from './HeroImageContainer.module.css';

const HeroImageContainer = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    // Image data - REPLACE THESE WITH YOUR ACTUAL 3 DIFFERENT IMAGES
    const slides = [
        {
            id: 1,
            desktopSrc: "https://c.animaapp.com/mhof1dcsmYxOSQ/assets/53eacf_007da85938664752a037f586328a60cf~mv2.png",
            mobileSrc: "https://c.animaapp.com/mhof1dcsmYxOSQ/assets/53eacf_e9a337e83834401ebfff8b0bcf1908c8~mv2.png",
            alt: "Connect with stars"
        },
        {
            id: 2,
            desktopSrc: "https://c.animaapp.com/mhof1dcsmYxOSQ/assets/53eacf_007da85938664752a037f586328a60cf~mv2.png", // REPLACE with actual second desktop image
            mobileSrc: "https://c.animaapp.com/mhof1dcsmYxOSQ/assets/53eacf_e9a337e83834401ebfff8b0bcf1908c8~mv2.png", // REPLACE with actual second mobile image
            alt: "Make forever moments"
        },
        {
            id: 3,
            desktopSrc: "https://c.animaapp.com/mhof1dcsmYxOSQ/assets/53eacf_007da85938664752a037f586328a60cf~mv2.png", // REPLACE with actual third desktop image
            mobileSrc: "https://c.animaapp.com/mhof1dcsmYxOSQ/assets/53eacf_e9a337e83834401ebfff8b0bcf1908c8~mv2.png", // REPLACE with actual third mobile image
            alt: "Personalized shoutouts"
        }
    ];

    // Auto-slide functionality
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [slides.length]);

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    // Get current image based on screen size
    const getCurrentImage = () => {
        const isDesktop = window.innerWidth >= 768;
        const currentSlideData = slides[currentSlide];
        return {
            src: isDesktop ? currentSlideData.desktopSrc : currentSlideData.mobileSrc,
            alt: currentSlideData.alt
        };
    };

    return (
        <div
            role="group"
            className={styles.imageContainer}
        >
            <div className={styles.imageWrapper}>
                <div className={styles.imageGrid}>
                    <div className={styles.imageInner}>

                        {/* Single Image Container - Much Simpler */}
                        <div className={styles.sliderContainer}>
                            {slides.map((slide, index) => {
                                const isDesktop = window.innerWidth >= 768;
                                const imageSrc = isDesktop ? slide.desktopSrc : slide.mobileSrc;

                                return (
                                    <div
                                        key={slide.id}
                                        className={`${styles.slide} ${index === currentSlide ? styles.active : ''}`}
                                    >
                                        <img
                                            src={imageSrc}
                                            alt={slide.alt}
                                            className={styles.slideImage}
                                        />
                                    </div>
                                );
                            })}
                        </div>

                        {/* Slider Dots */}
                        <div className={styles.sliderControls}>
                            {slides.map((_, index) => (
                                <button
                                    key={index}
                                    className={`${styles.sliderDot} ${index === currentSlide ? styles.activeDot : ''}`}
                                    onClick={() => goToSlide(index)}
                                    aria-label={`Go to slide ${index + 1}`}
                                />
                            ))}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroImageContainer;